
export default {
  green1: '#35e65d',
  grey1: '#f4f7f9',
  grey2: '#cdd8ec',
  grey3: '#b5b5b5',
  grey4: '#868686',
  grey5: '#585858',
  grey6: '#F2F9FF',
  grey7: '#EAEDF2',
  turqois1: '#35cce6',
  turqois2: '#a3eaf7',
  white: '#fff',
  white_50: 'rgba(255,255,255, 0.5)',
  white_80: 'rgba(255,255,255, 0.8)',
  red: '#ff0000',
  black: '#000000',

  main_blue: '#00ADEF',
  main_blue_active: '#00bfff',
  main_blue_40: 'rgba(0, 173, 239, 0.4)',
  main_blue_50: 'rgba(0, 173, 239, 0.5)',

  message_bubble_bot: '#EAEDF2',
  message_bubble_user: '#F2F9FF',

  btn_slide: '#3588eb',
  btn_slide_hover: '#3598ff',
  btn_disabled: '#779caf',

  scrollBarWidth: '20px',
}



// WEBPACK FOOTER //
// ./src/ChatWidget/components/common/vars.js